import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNBCUSDK } from "../context/sdk/useSDK.js";

import './AgeVerification.css';

const epic_logo = require('../assets/UEU-Logo-Drop-Shadow_optimized 1.png');

const AgeVerification = () => {
  const [open, setOpen] = useState(true);
  const [birthDate, setBirthDate] = useState('2025-05-22');
  const [error, setError] = useState('');
  const [blocked, setBlocked] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { handleOAuthLogin } = useNBCUSDK();

  useEffect(async () => {
    const ageVerified = getCookie('ageVerified');
    if (ageVerified === 'true') {
      await handleOAuthLogin();
      // setOpen(false);
    } else if (ageVerified === 'false') {
      setBlocked(true);
      setOpen(true);
    } else {
      setOpen(true);
    }
  }, []);

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const handleSubmit = async () => {
    const age = calculateAge(birthDate);
    if (isNaN(age)) {
      setError('Please enter a valid date.');
    } else if (age >= 18) {
      setCookie('ageVerified', 'true', 365);
      await handleOAuthLogin();
      setOpen(false);
    } else {
      setCookie('ageVerified', 'false', 365);
      setBlocked(true);
      setError('');
    }
  };

  return (
    <Modal open={open} onClose={() => {}} disableEscapeKeyDown>
      <Box className="age-modal-box background">
        <img src={epic_logo} style={{
          display: 'block',
          margin: '0 auto',
          width: '100%',
          maxWidth: 270
        }} alt="Age Modal"/>
        <h3 style={{
          fontSize: isSmallScreen ? '16px' : '18px',
          fontWeight: 500,
          color: '#ffffff',
          margin: '0 auto',
          marginTop: 80,
          padding: '0 10px',
          display: 'block'
        }}>
          {blocked ? 'Sorry, you must be 18 years of age or older to participate in this experience.' : 'Before we get started, let’s verify your age.'}
        </h3>
        {!blocked && (
          <>
            <TextField
              className="datetime"
              type="date"
              placeholder="MM/DD/YYYY"
              value={birthDate || ""}
              onChange={(e) => {
                setBirthDate(e.target.value);
                setError('');
              }}
              inputProps={{
                inputMode: 'numeric', // shows number keyboard on mobile
                pattern: "\\d{2}/\\d{2}/\\d{4}", // optional pattern
              }}
              sx={{
                '& input::-webkit-calendar-picker-indicator': {
                  display: 'none',
                  WebkitAppearance: 'none',
                },
                '& input': {
                  textAlign: 'center'
                },
              }}
              // sx={{
              //   width: '220px',
              //   margin: '16px auto',
              //   display: 'block',
              //   border: '2px solid #ffffff',
              //   borderRadius: 100,
              //   backgroundColor: '#051031',
              //   '& input': {
              //     padding: '12px',
              //     color: '#ffffff'
              //   },
              // }}
            />
            {error && (
              <Typography color="error" variant="body2" align="center">
                {error}
              </Typography>
            )}
            <Button
              variant="contained"
              disabled={!birthDate || birthDate == '2025-05-22'}
              onClick={handleSubmit}
              style={{
                background: '#d2ac55',
                marginTop: 60,
                width: '80%',
                color: '#000000',
                fontWeight: 600,
                textTransform: 'none',
                maxWidth: 300
              }}
              sx={{
                borderRadius: '999px',
                marginTop: '16px',
                padding: '10px 24px',
                width: '160px',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                boxShadow: 'none'
              }}
            >
              Enter
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AgeVerification;